<template>
  <div class="password-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <div class="input-group">
          <template v-if="isVisible">
            <input class="form-control" type="text"
              :id="options.name"
              :value="options.value"
              :name="options.name"
              @input="validate($event.target.value)"/>
          </template>
          <template v-else>
            <input class="form-control" type="password"
            :id="options.name"
            :value="options.value"
            :name="options.name"
            @input="validate($event.target.value)"/>
          </template>
          <span class="input-group-btn">
            <button class="btn btn-info" type="button" @click="toggle()">
              <span class="fa fa-fw" :class="{
                'fa-eye' : !isVisible,
                'fa-eye-slash' : isVisible
              }"></span>
            </button>
          </span>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationMessage,
  validationIcon
} from '@/util/helpers'

export default {
  name: 'PasswordInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      isValid: false,
      isDirty: false,
      isVisible: false
    }
  },
  computed: {
    validationClass,
    validationMessage,
    validationIcon,
    invalidMessage () {
      return this.options.label + ' is required'
    }
  },
  methods: {
    toggle () {
      this.isVisible = !this.isVisible
    },
    validate (val = this.value) {
      this.$emit('input', val)
      this.isDirty = true
      this.isValid = val.length > 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/PasswordInput.vue